import { PHONE_CODES } from '../../config/phone_code_config'

export function buildPhoneCodes() {
  /*   const PHONE_CODES = [
    {
      country: 'alemania',
      code: PREFIX_PHONE_LIST.GERMAN_PHONE
    },
    {
      country: 'reino unido',
      code: PREFIX_PHONE_LIST.UK_PHONE
    },
    {
      country: 'francia',
      code: PREFIX_PHONE_LIST.FRENCH_PHONE
    },
    {
      country: 'bélgica',
      code: PREFIX_PHONE_LIST.BELGIAN_PHONE
    },
    {
      country: 'dinamarca',
      code: PREFIX_PHONE_LIST.DANISH_PHONE
    },
    {
      country: 'irlanda',
      code: PREFIX_PHONE_LIST.IRISH_PHONE
    },
    {
      country: 'noruega',
      code: PREFIX_PHONE_LIST.NORWEGIAN_PHONE
    },
    {
      country: 'suecia',
      code: PREFIX_PHONE_LIST.SWEDISH_PHONE
    },
    {
      country: 'países bajos',
      code: PREFIX_PHONE_LIST.DUTCH_PHONE
    },
    {
      country: 'suiza',
      code: PREFIX_PHONE_LIST.SWISS_PHONE
    },
    {
      country: 'austria',
      code: PREFIX_PHONE_LIST.AUSTRIAN_PHONE
    }
  ] */

  const $selectToCodes = document.getElementById('custom-budget-phone-code')

  const uniqueCodesSet = new Set()

  PHONE_CODES.sort((a, b) => a.code - b.code)
    .filter(({ code }) => code)
    .forEach(({ code }) => {
      if (!uniqueCodesSet.has(code)) {
        // Si no está, agregarlo al conjunto y al elemento select
        const valueLessPlus = code.replace('+', '')
        uniqueCodesSet.add(code)
        const option = document.createElement('option')
        option.textContent = code
        option.value = valueLessPlus
        $selectToCodes.appendChild(option)
      }
    })

  const otherOption = document.createElement('option')
  otherOption.textContent = 'Other'
  otherOption.value = 'other'
  $selectToCodes.appendChild(otherOption)

  return $selectToCodes
}
